// Check if i should move from conversation-enums.ts to here

export function getRandomVoice(langCode: string): string {
  const voices = DefaultTalkVoice[langCode];
  const randomKey = Object.keys(voices)[Math.floor(Math.random() * Object.keys(voices).length)];
  return voices[randomKey];
}

export const DefaultTalkVoice = {
  fr: {
    woman: 'fr-FR-Chirp3-HD-Zephyr',
    man: 'fr-FR-Chirp3-HD-Fenrir',
  },
  en: {
    woman: 'en-US-Chirp3-HD-Leda',
    man: 'en-US-Neural2-I',
  },
  es: {
    woman: 'es-US-Neural2-A',
    man: 'es-US-Chirp3-HD-Orus',
  },
  de: {
    woman: 'de-DE-Standard-E',
    man: 'de-DE-Neural2-C',
  },
  it: {
    woman: 'it-IT-Neural2-E',
    man: 'it-IT-Chirp3-HD-Charon',
  },
  pt: {
    woman: 'pt-BR-Chirp3-HD-Leda',
    man: 'pt-BR-Neural2-B',
  },
  ja: {
    woman: 'ja-JP-Neural2-B',
    man: 'ja-JP-Chirp3-HD-Puck',
  },
};

export const DefaultBestVoice = {
  en: {
    woman: 'en-US-Studio-O',
    man: 'en-US-Studio-Q',
  },
  'en-GB': {
    woman: 'en-GB-Studio-B',
    man: 'en-GB-Studio-C',
  },
  de: {
    woman: 'de-DE-Studio-B',
    man: 'de-DE-Studio-C',
  },
  'es-ES': {
    woman: 'es-ES-Studio-C',
    man: 'es-ES-Studio-F',
  },
  fr: {
    woman: 'df-FR-Studio-A',
    man: 'df-FR-Studio-D',
  },
  es: {
    woman: 'es-US-Standard-A', // No voice Studio Available yet
    man: 'es-US-Studio-B',
  },
  // Next voices are chirp since they are not available in Studio
  it: {
    woman: 'it-IT-Standard-E',
    man: 'it-IT-Neural2-F',
  },
  pt: {
    woman: 'pt-BR-Neural2-C',
    man: 'pt-BR-Chirp3-HD-Fenrir',
  },
  ja: {
    woman: 'ja-JP-Standard-A',
    man: 'ja-JP-Neural2-C',
  },
};

export const DefaultQuickVoice = {
  ja: {
    female: ['ja-JP-Neural2-B', 'ja-JP-Standard-A', 'ja-JP-Standard-B'],
    male: ['ja-JP-Neural2-C', 'ja-JP-Neural2-D', 'ja-JP-Standard-C'],
  },

  es: {
    female: ['es-US-Neural2-A'],
    male: ['es-US-Neural2-B', 'es-US-Neural2-C'],
  },
  fr: {
    female: ['fr-FR-Neural2-F'],
    male: ['fr-FR-Neural2-G'],
  },

  // TODO: verify this voices exists.
  en: {
    female: ['en-US-Standard-A', 'en-US-Standard-B', 'en-US-Standard-C'],
    male: ['en-US-Standard-D', 'en-US-Standard-E', 'en-US-Standard-F'],
  },

  it: {
    female: ['it-IT-Standard-E', 'it-IT-Neural2-F'],
    male: ['it-IT-Standard-F', 'it-IT-Neural2-G'],
  },
  pt: {
    female: ['pt-BR-Neural2-C', 'pt-BR-Chirp3-HD-Fenrir'],
    male: ['pt-BR-Neural2-D', 'pt-BR-Chirp3-HD-Galatea'],
  },
};

export const getRandomQuickVoice = (language: keyof typeof DefaultQuickVoice, gender: 'female' | 'male'): string => {
  const languageVoicesGroup = DefaultQuickVoice[language];

  if (languageVoicesGroup) {
    const specificGenderVoices = languageVoicesGroup[gender];
    if (specificGenderVoices && specificGenderVoices.length > 0) {
      return specificGenderVoices[Math.floor(Math.random() * specificGenderVoices.length)];
    }
  }

  // If we reach here, the primary language/gender combo was not found or empty
  console.warn(
    `Quick voices for language "${String(language)}" and gender "${gender}" not found or empty. Attempting fallback to 'en' with gender "${gender}".`,
  );

  // 'en' is present in DefaultQuickVoice, and 'woman'/'man' keys are also present for 'en'.
  const fallbackLanguageVoicesGroup = DefaultQuickVoice['en'];
  const fallbackSpecificGenderVoices = fallbackLanguageVoicesGroup[gender];

  if (fallbackSpecificGenderVoices && fallbackSpecificGenderVoices.length > 0) {
    console.log(`Using fallback 'en' with gender "${gender}" for quick voice selection.`);
    return fallbackSpecificGenderVoices[Math.floor(Math.random() * fallbackSpecificGenderVoices.length)];
  }

  // If both primary and fallback 'en' for the specific gender fail (e.g. empty voice list for 'en')
  throw new Error(
    `Could not find any suitable quick voices for language "${String(
      language,
    )}" and gender "${gender}", nor for fallback 'en' with gender "${gender}". Voice list might be empty. Please check DefaultQuickVoice data.`,
  );
};

// export const VoiceTTSOptions: VoiceTTSOption[] = [
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇫🇷 fr-FR-Neural2-B',
//     id: 'fr-FR-Neural2-B',
//     gender: 'male',
//     lang: 'fr-FR',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_fr-FR-Neural2-B.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇫🇷 fr-FR-Neural2-E',
//     id: 'fr-FR-Neural2-E',
//     gender: 'female',
//     lang: 'fr-FR',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_fr-FR-Neural2-E.mp3',
//   },
//   // Italian
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇮🇹 it-IT-Neural2-A',
//     id: 'it-IT-Neural2-A',
//     gender: 'female',
//     lang: 'it-IT',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_it-IT-Neural2-A.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️  🇮🇹 it-IT-Neural2-C',
//     id: 'it-IT-Neural2-C',
//     gender: 'male',
//     lang: 'it-IT',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_it-IT-Neural2-C.mp3',
//   },
//   // Portuguese
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇧🇷 pt-BR-Neural2-C',
//     id: 'pt-BR-Neural2-C',
//     gender: 'female',
//     lang: 'pt-BR',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_pt-BR-Neural2-C.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇧🇷 pt-BR-Neural2-B',
//     id: 'pt-BR-Neural2-B',
//     gender: 'male',
//     lang: 'pt-BR',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_pt-BR-Neural2-B.mp3',
//   },
//   // Spanish
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man 🇲🇽 es-US-Neural2-B',
//     id: 'es-US-Neural2-B',
//     gender: 'male',
//     lang: 'es-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-US-Neural2-B.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇲🇽 es-US-Neural2-A',
//     id: 'es-US-Neural2-A',
//     gender: 'female',
//     lang: 'es-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-US-Neural2-A.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇲🇽 es-US-Neural2-C',
//     id: 'es-US-Neural2-C',
//     gender: 'male',
//     lang: 'es-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-US-Neural2-C.mp3',
//   },

//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇪🇸 es-ES-Neural2-B',
//     id: 'es-ES-Neural2-B',
//     gender: 'male',
//     lang: 'es-ES',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-B.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇪🇸 es-ES-Neural2-C',
//     id: 'es-ES-Neural2-C',
//     gender: 'male',
//     lang: 'es-ES',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-C.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇪🇸 es-ES-Neural2-F',
//     id: 'es-ES-Neural2-F',
//     gender: 'male',
//     lang: 'es-ES',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-F.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇪🇸 es-ES-Neural2-E',
//     id: 'es-ES-Neural2-E',
//     gender: 'female',
//     lang: 'es-ES',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-E.mp3',
//   },

//   // English
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-F',
//     id: 'en-US-Journey-F',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Journey-F.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-O',
//     id: 'en-US-Journey-O',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Journey-O.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-D',
//     id: 'en-US-Journey-D',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Journey-D.mp3',
//   },

//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-N',
//     id: 'en-US-News-N',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-News-N.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-News-L',
//     id: 'en-US-News-L',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-News-L.mp3',
//   },

//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-Neural2-F',
//     id: 'en-US-Neural2-F',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-F.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👩 Woman ♀️ 🇺🇸 en-US-Neural2-H',
//     id: 'en-US-Neural2-H',
//     gender: 'female',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-H.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇺🇸 en-US-Neural2-J',
//     id: 'en-US-Neural2-J',
//     gender: 'male',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-J.mp3',
//   },
//   {
//     provider: 'google',
//     name: '👨‍🦰 Man ♂️ 🇺🇸 en-US-Neural2-I',
//     id: 'en-US-Neural2-I',
//     gender: 'male',
//     lang: 'en-US',
//     exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-I.mp3',
//   },
// ];
